// German number formats: 1.234,5 mm · 45,0° · 0,012 m³

const nf = (min, max) => new Intl.NumberFormat('de-DE', { minimumFractionDigits: min, maximumFractionDigits: max })
const n0 = nf(0, 1), n1 = nf(1, 1), n2 = nf(0, 2), n3 = nf(0, 3)

export const mm = (x) => (Number.isFinite(x) ? n0.format(Math.round(x * 2) / 2) : '–')
export const mmU = (x) => `${mm(x)} mm`
export const degf = (x) => `${n1.format(x)}°`
export const num = (x, d = 1) => (d === 0 ? Math.round(x).toLocaleString('de-DE') : nf(0, d).format(x))
export const kg = (x) => `${n2.format(x)} kg`
export const m2 = (x) => `${n2.format(x)} m²`
export const m3 = (x) => `${n3.format(x)} m³`
export const dims = (a) => a.map(mm).join(' × ')
/** Half-millimetre rounding — what a tape measure resolves. */
export const half = (x) => Math.round(x * 2) / 2
